// extracted by mini-css-extract-plugin
export default {"cls1":"PageSizeMenu-Button_cls1__jg2VX","cls2":"PageSizeMenu-Button_cls2__0V2uW PageSizeMenu-Button_cls1__jg2VX"};